module.exports = __webpack_public_path__ + "static/media/training-tertiary-hero.f1196ebf.png";